import { PaginationTable } from '../../../../common/components';

const ConstructionTypesPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <PaginationTable
      totalPages={totalPages}
      totalCount={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      entityName="tipo de construcción"
      entityNamePlural="tipos de construcción"
    />
  );
};

export default ConstructionTypesPagination;
